"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoPlacementStartRequestBodySchema = exports.AutoPlacementApi = exports.ApplyAutoPlacementJobRequestBodySchema = exports.DiscardAutoPlacementJobRequestBodySchema = exports.ResumeAutoPlacementJobRequestBodySchema = exports.PauseAutoPlacementJobRequestBodySchema = exports.ConfirmAutoPlacementJobRequestBodySchema = exports.SubmitAutoPlacementJobRequestBodySchema = exports.BaseAutoPlacementJobRequestBodySchema = exports.autoPlacementJobUidSchema = exports.AutoPlacementApiStructure = void 0;
const zod_1 = require("zod");
const backendProxy_1 = require("../backendProxy");
const identifier_1 = require("../identifier");
const Action = zod_1.z.enum(["start_job", "project_job_step", "cancel_job", "pause_job", "resume_job", "apply_job"]);
const Paths = zod_1.z.object(Action.options.reduce((acc, key) => {
    acc[key] = zod_1.z.string();
    return acc;
}, {}));
const VersionDefinition = zod_1.z
    .object({
    host: zod_1.z.string(),
    paths: Paths,
})
    .strict();
const Version = zod_1.z.enum(["v1"]);
const Versions = zod_1.z.object(Version.options.reduce((acc, key) => {
    acc[key] = VersionDefinition;
    return acc;
}, {}));
const host = process.env.REACT_APP_AUTOPLACEMENT_HOST
    ? process.env.REACT_APP_AUTOPLACEMENT_HOST
    : process.env.REACT_APP_AUTOPLACEMENT_ENVIRONMENT === "emulated"
        ? "http://localhost:8083"
        : "https://auto-placement-app-myfpimhjlq-wl.a.run.app";
exports.AutoPlacementApiStructure = Versions.parse({
    v1: {
        host,
        paths: {
            start_job: "/start_job",
            project_job_step: "/project_job_step",
            cancel_job: "/cancel_job",
            pause_job: "/pause_job",
            resume_job: "/resume_job",
            apply_job: "/apply_job",
        },
    },
});
const urlFor = (name, version) => backendProxy_1.AutoPlacement.resolve(exports.AutoPlacementApiStructure[version].paths[name]);
exports.autoPlacementJobUidSchema = zod_1.z.custom((s) => typeof s === "string" && s.startsWith("auto-placement-"));
exports.BaseAutoPlacementJobRequestBodySchema = zod_1.z.object({
    userUid: identifier_1.UserUid,
    jobUid: exports.autoPlacementJobUidSchema,
    organizationUid: identifier_1.optionalOrganizationUid,
});
exports.SubmitAutoPlacementJobRequestBodySchema = zod_1.z.object({
    ...exports.BaseAutoPlacementJobRequestBodySchema.shape,
    inputBoardLocation: zod_1.z.string(),
    projectPath: zod_1.z
        .string()
        .regex(/^[a-z0-9-]+\/[a-z0-9-]+$/)
        .optional(),
});
exports.ConfirmAutoPlacementJobRequestBodySchema = exports.BaseAutoPlacementJobRequestBodySchema;
exports.PauseAutoPlacementJobRequestBodySchema = exports.BaseAutoPlacementJobRequestBodySchema;
exports.ResumeAutoPlacementJobRequestBodySchema = exports.BaseAutoPlacementJobRequestBodySchema;
exports.DiscardAutoPlacementJobRequestBodySchema = exports.BaseAutoPlacementJobRequestBodySchema;
exports.ApplyAutoPlacementJobRequestBodySchema = zod_1.z.object({
    ...exports.BaseAutoPlacementJobRequestBodySchema.shape,
    iterationIndex: zod_1.z.number().int().nonnegative().optional(),
});
exports.AutoPlacementApi = {
    urlFor,
    versionParse: Version.default("v1").catch("v1").parse,
    version: Version.enum,
    action: Action.enum,
};
exports.AutoPlacementStartRequestBodySchema = zod_1.z.object({
    userUid: identifier_1.UserUid,
    jobUid: exports.autoPlacementJobUidSchema,
    organizationUid: identifier_1.optionalOrganizationUid,
});
//# sourceMappingURL=api.js.map